import React from "react";
//#region types
import { CommentItem, ManualConversationProps } from "models/propTypes/commentViewPropTypes";
import { User } from "models/propTypes/userProfilePropTypes";
//#endregion
//#region components
import { Grid, Divider } from "@mui/material";
import { Comments } from "components/common";
import { useGenericCommentService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ManualConversation: React.FC<ManualConversationProps> = ({ parentId, commentType }) => {
  const genericCommentsService = useGenericCommentService();
  const [comments, setComments] = React.useState<CommentItem[]>();

  React.useEffect(() => {
    if (!parentId) return;

    genericCommentsService.getGenericComments(parentId, commentType).then((result) => {
      const comments =
        result.items
          ?.filter((c) => c.isManual)
          .map((c): CommentItem => {
            return {
              id: parentId,
              message: c.message ?? "",
              from: new User(c.authorId, c.authorName),
              date: c.created,
              isAutomatic: false,
            };
          }) ?? [];
      setComments(comments);
    });
  }, [parentId]);

  return comments?.length ? (
    <Grid container rowGap={1.25}>
      <Grid container>
        <Divider className={cssExports.dividerGray} />
      </Grid>

      <Grid container>
        <Comments parentId={`CommentsWithFileUploader-${parentId}`} viewCountIncreaseBy={2} comments={comments} />
      </Grid>

      <Grid container>
        <Divider className={cssExports.dividerGray} />
      </Grid>
    </Grid>
  ) : (
    <></>
  );
};

export default ManualConversation;
